import { Home } from 'lucide-react';
import type { User } from '@/types/user.types';
import { formatDataHoraPartes } from '@/utils/formatters';
import { UserIdentity } from './UserIdentity';
import { SubscriptionBadge } from './SubscriptionBadge';
import { UserActionsMenu } from './UserActionsMenu';

interface UserTableRowProps {
  user: User;
  onViewDetails?: (id: string) => void;
  onEdit?: (id: string) => void;
  onBlock?: (id: string) => void;
  onUnblock?: (id: string) => void;
  onDelete?: (id: string) => void;
  onManageSubscription?: (id: string) => void;
}

// Linha densa da tabela (desktop). Colunas: Usuário | Assinatura | Propriedade
// | Último acesso | Ações. Verificado e cargo·telefone ficam dentro do Usuário.
export function UserTableRow({
  user,
  onViewDetails,
  onEdit,
  onBlock,
  onUnblock,
  onDelete,
  onManageSubscription,
}: UserTableRowProps) {
  const propName = typeof user.property === 'string' ? user.property : user.property?.name || 'N/A';
  const acesso = formatDataHoraPartes(user.lastAccess);

  return (
    <tr className="transition-colors hover:bg-muted/40">
      <td className="px-5 py-3">
        <UserIdentity user={user} />
      </td>
      <td className="px-5 py-3">
        <SubscriptionBadge user={user} onManage={onManageSubscription} />
      </td>
      <td className="px-5 py-3">
        <span className="inline-flex min-w-0 items-center gap-1.5 text-sm text-text-secondary">
          <Home size={14} className="shrink-0 text-text-hint" />
          <span className="truncate">{propName}</span>
        </span>
      </td>
      {/* Data presa à esquerda, hora à direita: as duas pontas ficam retas
          mesmo com "Mai" e "Jan" tendo larguras diferentes na fonte. */}
      <td className="whitespace-nowrap px-5 py-3">
        <p className="flex items-baseline justify-between gap-4 text-sm tabular-nums text-text-title">
          <span>{acesso.data}</span>
          {acesso.hora && <span className="text-text-secondary">{acesso.hora}</span>}
        </p>
        {user.lastDevice && user.lastDevice !== 'N/A' && (
          <p className="text-xs text-text-secondary">{user.lastDevice}</p>
        )}
      </td>
      <td className="px-5 py-3 text-right">
        <UserActionsMenu
          user={user}
          onViewDetails={onViewDetails}
          onEdit={onEdit}
          onBlock={onBlock}
          onUnblock={onUnblock}
          onDelete={onDelete}
          onManageSubscription={onManageSubscription}
        />
      </td>
    </tr>
  );
}
